"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Signaling client role.
 */
var Role;
(function (Role) {
    Role["MASTER"] = "MASTER";
    Role["VIEWER"] = "VIEWER";
})(Role = exports.Role || (exports.Role = {}));
//# sourceMappingURL=Role.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/amazon-kinesis-video-streams-webrtc/lib/Role.js
// module id = 236
// module chunks = 0